import axios, { AxiosResponse } from 'axios';
import { EmbeddedPowerBIReport } from 'views/power-bi-reports/types/embedded-power-bi-report.type';

// GET
// /ewosapi/v1/powerbi/company/{globalCompanyId}/reports/{powerBIReportId}/embed
export const getEmbeddedPowerBIReport = async (globalCompanyId: string, powerBIReportId: string): Promise<EmbeddedPowerBIReport> => {
  const res = await axios.get<EmbeddedPowerBIReport>(`/ewosapi/v1/powerbi/company/${globalCompanyId}/reports/${powerBIReportId}/embed`);
  return res.data;
};

// GET
// /ewosapi/v1/GlobalSettings/pbi-report
export const getPowerBIReportGlobalSettings = async (): Promise<{ exportEnabled: true }> => {
  const res = await axios.get<{ exportEnabled: true }>(`/ewosapi/v1/globalsettings/pbi-report`);
  return res.data;
};

// GET
// /ewosapi/v1/powerbi/company/{globalcompanyId}/reports/{powerBiReportId}/export/{exportId}/download
export const downloadPowerBIReport = async (
  globalCompanyId: string,
  powerBIReportId: string,
  exportId: string
): Promise<AxiosResponse> => {
  return await axios.get<AxiosResponse>(
    `/ewosapi/v1/powerbi/company/${globalCompanyId}/reports/${powerBIReportId}/export/${exportId}/download`,
    {
      responseType: 'blob',
    }
  );
};
